async function upload(product) {
    try {
        await cf.plot_3d.plot_from_console(product);
        var sp = new save_pics("container_3d");
        sp.cropping = true;
        await sp.upload(product);
    }
    catch(err) {

    }
    $(".button-close").click();
}

async function plot_i (i) {
    $(".button-close").click();
    var data = mp_data;
    // cf.plot_3d.fl_3d.show_body_axis = true;
    await cf.plot_3d.plot_from_console(data[i]);
    
}

function missing_mp() {
    var data = mp_data;

    for (var i = 1; i < data.length; i++) {
        if (!data[i].glb_array.length) {
    
        }
    }
}

async function check_mp( i = 1) {
    var data = mp_data;
    await plot_i(i);
    i += await get_i();
    if (i < 1) {
        i = 1;
    } else if (i > data.length - 1){
        i = data.length - 1;
    }
    check_mp(i);
}

async function loop(what){
    var data;

    if (what === "gs") {
        data = gs_data;
    } else if (what === "mp") {
        data = mp_data;
    } else {
        alert("Please input gs or mp for gassprings or mounting parts");
    }

    for (var i = 0; i < data.length; i++) {
        if (data[i].glb_array.length) {
            await upload(data[i]);
        }
    }
}


function get_i() {
    return new Promise(resolve => {
        const handler = (event) => {
            if (event.key === 'ArrowRight') {
                document.removeEventListener('keydown', handler);
                resolve(1); // Move to the next iteration
            } else if (event.key === 'ArrowLeft') {
                document.removeEventListener('keydown', handler);
                resolve(-1); // Move to the previous iteration
            }
        };
        document.addEventListener('keydown', handler);
    });
}
function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}